var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChessActiveicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.0002H5V20.0002H19V22.0002ZM16 18.0002H8L10.18 10.0002H8V8.00025H10.72L10.79 7.74025C10.1002 7.44044 9.54981 6.89007 9.25 6.20025C8.58 4.68025 9.27 2.91025 10.79 2.25025C12.31 1.58025 14.08 2.27025 14.74 3.79025C14.8993 4.15058 14.9858 4.53884 14.9946 4.93271C15.0034 5.32659 14.9342 5.71832 14.7911 6.08538C14.648 6.45244 14.4338 6.7876 14.1607 7.0716C13.8877 7.3556 13.5612 7.58284 13.2 7.74025L13.27 8.00025H16V10.0002H13.82L16 18.0002Z",
    fill: "#BD3193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessActiveicon);
export default __webpack_public_path__ + "static/media/ChessActiveicon.bce17cb9c88f81c8fdec761351968ee2.svg";
export { ForwardRef as ReactComponent };